// eslint-disable-next-line no-restricted-imports -- Use the SDK contract for boundary types.
import { type PostHogConfig } from 'posthog-js';

import { isDefined } from 'common';

import { sanitizeUrls } from './Urls/sanitize';
import { filterOutboundEvent } from './filterOutboundEvent';

export const staffPostHogOptions: Partial<PostHogConfig> = {
  api_host: 'https://us.i.posthog.com',
  defaults: '2025-05-24',
  autocapture: false,
  capture_dead_clicks: false,
  /** PostHog flags can send person properties before before_send; the app uses its own flags. */
  advanced_disable_flags: true,
  capture_exceptions: false,
  enable_recording_console_log: false,
  mask_all_text: true,
  mask_all_element_attributes: true,
  before_send: (event) => {
    const allowedEvent = filterOutboundEvent(event);
    return isDefined(allowedEvent) ? sanitizeUrls(allowedEvent) : null;
  },
  capture_performance: false,
  capture_heatmaps: false,
  disable_surveys: true,
  disable_conversations: true,
  disable_product_tours: true,
  disable_session_recording: true,
  capture_pageview: false,
  capture_pageleave: false,
};
